
<template>
  <div no-gutters class="lc-floating-bar" :style="{zIndex: 150, width: '32px', height: '32px'}">
    <v-btn class="lc-floating-bar" icon @click="toggleLayerControl">
      <v-icon class="ml-n1 mt-n1" color="white">{{ show ? 'mdi-layers-outline' : 'mdi-layers' }}</v-icon>
    </v-btn>
  </div>

</template>

<style scoped>

</style>
<script>
export default {
  name: 'LayerControlToggle',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    toggleLayerControl() {
      this.$emit('update:show', !this.show);
    },
  },
};
</script>
